<template>
<div class="updataUser-container">
   <div class="head">
    <p>修改用户信息</p>
   </div>
   <el-form  label-position="right" label-width="120px">
    <el-form-item label="修改用户头像">
       <el-upload
  class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  :show-file-list="false"
 >
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
<div class="iconbox" v-else>
 <i  class="el-icon-plus avatar-uploader-icon"></i>
    <p>点击上传</p>
</div>
</el-upload> 
    <div class="el-upload__tip" >请上传JPEG/PNG格式的图片，大小5MB以内</div>
    </el-form-item>

    <el-form-item label="修改用户名">
<el-input
  type="text"
  placeholder="请输入用户名"
  v-model="text"
  maxlength="30"
  show-word-limit
/>
    </el-form-item>
    <el-form-item>
        <div class="btnList">
            <button class="sucess">确认</button>
            <button class="del">取消</button>
        </div>
    </el-form-item>
   </el-form>
</div>
</template>

<script>
export default {
data(){
    return{imageUrl:'',text:''}
}
}
</script>

<style scoped>
.el-upload__tip{
    font-size: 12px;
    color: #999;
}
.sucess{
    background-color: #0D53FF;
    color: white;
  
}
.del{
    background-color: #fff;
    color: #666666;
    
}
.btnList button{
    width: 80px;
    height: 32px;
       border: 1px solid #E9E9E9;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 4px;
}
::v-deep .el-input{
    width: 570px;
    height: 36px;
}
.iconbox{
width: 100%;
height: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   color: #E0E0E0;
 
}
.iconbox p{
    margin-top: 12px;
    font-size: 12px;
    line-height: 17px;
    height: 17px;
}
.el-icon-plus{
    font-size: 20px;
    
 
}
::v-deep .el-upload{
    width: 100px;height: 100px;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
          
}

.updataUser-container{
    margin-top: 24px;
    margin-left: 24px;
     font-family: Regular;
}
.head{
    font-size: 24px;
    font-family: Medium;
    margin-bottom: 27px;

}
</style>